export default function InputField({ onChange, type = "number", value }) {
  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      onClick={(e) => e.target.select()}
      className="w-full px-2 py-1  w-[5rem] text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
    />
  );
}
